import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

export function SessionExpired() {
    return (<>
        <div className='flex-1 lg:flex-none text-center space-y-6'>
            <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
            <h1 className="text-2xl text-gray-900 font-medium mb-4">
                Your session has expired.
            </h1>
        </div>
        <Button className="w-full mt-8"
            color="gray"
            onClick={() => {
                window.close();
                if (!window.closed) {
                    window.location.href = import.meta.env.VITE_MYHEALTH_WEBSITE;
                }
            }}>
            Exit
        </Button>
    </>
    );
}
